import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { SpinnerService } from '../services/spinner.service';
import { SpinnerSkipUrlsConstants } from '../constants/spinner-skip-urls.constants';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  constructor(private spinnerService: SpinnerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if this request should bypass loading spinner via header
    const ignoreLoading = request.headers.has('X-IGNORE-LOADING');
    
    // Check if this URL should skip the global spinner
    const shouldSkip = SpinnerSkipUrlsConstants.shouldSkipSpinner(request.url);
    
    if (shouldSkip || ignoreLoading) {
      // Skip global spinner for this request - use custom spinner in component
      return next.handle(request);
    }  
    // Show spinner when request starts
    this.spinnerService.show();
    
    // Hide spinner when request completes (success or error)
    return next.handle(request).pipe(
      finalize(() => {
        this.hideSpinnerSafely();
      })
    );
  }

  private hideSpinnerSafely(): void {
    try {
      this.spinnerService.hide();
    } catch (error) {
        this.spinnerService.reset();
    }
  }
}
